import React from 'react';
import { View } from 'react-native';
import RadioButton from './RadioButton';
import { LocStr } from '../../../utils/Utils';
import { textPrimary_20_9 } from '../../SimulatorsComponents/AuxiliaryComponent/TextComponent/TextStyle';

//= ========================================================================

const RadioPanel = ({
  value,
  headlineLeftOption,
  headlineRightOption,
  onPressLeftOption,
  onPressRightOption,
  paddingStart = 20,
  language,
  title,
}) => (
  <View>
    {title
    && <textPrimary_20_9 style={{ fontWeight: 'bold', marginBottom: 8 }}>{title}</textPrimary_20_9>}
    <View style={{
      alignItems: 'center',
      flexDirection: 'row',
      marginBottom: 30,
      paddingStart,
    }}
    >
      <RadioButton
        text={LocStr(headlineLeftOption, language)}
        isSelected={value}
        onPress={onPressLeftOption}
      />
      <RadioButton
        text={LocStr(headlineRightOption, language)}
        isSelected={!value}
        onPress={onPressRightOption}
      />
    </View>
  </View>
);
export default RadioPanel;
